import { OrderStatusType } from '@/common/enums/order';

// No.208: 配送を追加 is not allowed while the order is in one of these states.
// waiting_payment stays allowed (customer decision, No.208 Q1 option B).
// One entry per blocked status: the reason shown on the disabled button and the API `code`
// returned for the same status. Must stay in sync with MakeDeliveryFeature::ensureOrderStatusIsValid
// and ExceptionTypes::MAKE_DELIVERY_ORDER_* (API).
export const MAKE_DELIVERY_BLOCKED_STATUSES: ReadonlyArray<{
  status: string;
  errorCode: string;
  reason: string;
}> = [
  {
    status: OrderStatusType.Cancelled,
    errorCode: 'errors.make_delivery_order_cancelled',
    reason: 'キャンセル済みのため配送追加できません。',
  },
  {
    status: OrderStatusType.Failure,
    errorCode: 'errors.make_delivery_order_failure',
    reason: '決済失敗のため配送追加できません。',
  },
];

export function getMakeDeliveryBlockedReason(
  status: string | null | undefined,
): string | null {
  if (!status) {
    return null;
  }

  const blocked = MAKE_DELIVERY_BLOCKED_STATUSES.find((entry) => entry.status === status);
  return blocked ? blocked.reason : null;
}

export function isMakeDeliveryDisabled(
  status: string | null | undefined,
): boolean {
  return getMakeDeliveryBlockedReason(status) !== null;
}

// Message to show when the API rejected 配送を追加 because of the order status, or null
// for any other error. Falls back to the local reason when the API sent no message.
export function getMakeDeliveryStatusErrorMessage(error: any): string | null {
  const data = error && error.response && error.response.data;
  const blocked = data && MAKE_DELIVERY_BLOCKED_STATUSES.find((entry) => entry.errorCode === data.code);
  if (!blocked) {
    return null;
  }

  return data.message || blocked.reason;
}
